import { render } from "./AvatarSelection.vue?vue&type=template&id=58649a75&scoped=true"
import script from "./AvatarSelection.vue?vue&type=script&lang=js"
export * from "./AvatarSelection.vue?vue&type=script&lang=js"

import "./AvatarSelection.vue?vue&type=style&index=0&id=58649a75&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58649a75"]])

export default __exports__